import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import cn from 'classnames';
import * as React from 'react';

import NavIcon from '../NavIcon/NavIcon';
import NavText from '../NavText/NavText';

import styles from './NavAccordionItem.module.scss';

interface IProps {
  title: string;
  icon?: React.ComponentType;
  activeIcon?: React.ComponentType;
  isActive?: boolean;
  isExpanded: boolean;
  onChange: () => void;
  children: React.ReactNode;
  className?: string;
}

const AccordionStyles = {
  backgroundColor: 'transparent',
  boxShadow: 'none',
  margin: '0 !important',
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: '0 !important',
  },
  '& .MuiAccordionSummary-root': {
    minHeight: 56,
    paddingX: 1,
    paddingY: 0,
    borderRadius: '8px',
    marginBottom: 1,
    '&.Mui-expanded': {
      minHeight: 56,
    },
  },
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    alignItems: 'center',
    margin: '0 !important',
    '&.Mui-expanded': {
      margin: '0 !important',
    },
  },
  '& .MuiAccordionDetails-root': {
    padding: 0,
  },
  '&:first-of-type': {
    borderRadius: 0,
  },
  '&:last-of-type': {
    borderRadius: 0,
  },
};

const NavAccordionItem: React.FC<IProps> = ({
  title,
  icon: IconComponent,
  activeIcon: IconActiveComponent,
  isActive = false,
  isExpanded,
  onChange,
  children,
  className,
}) => {
  const CurrentIcon = isActive && IconActiveComponent ? IconActiveComponent : IconComponent;

  return (
    <Accordion
      expanded={isExpanded}
      onChange={onChange}
      disableGutters
      className={cn(styles.sidenavAccordion, { [styles.expanded]: isExpanded }, className)}
      sx={{
        ...AccordionStyles,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className={styles.expandIcon} />}
        aria-controls={`${title}-content`}
        id={`${title}-header`}
        className={cn(styles.accordionSummary, { [styles.activated]: isActive })}
      >
        {IconComponent && (
          <NavIcon className={cn(styles.icon, { [styles.activated]: isActive })}>
            {CurrentIcon && <CurrentIcon />}
          </NavIcon>
        )}
        <div className={cn(styles.title, { [styles.activated]: isActive })}>
          <NavText title={title} />
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div className={styles.accordionContent}>{children}</div>
      </AccordionDetails>
    </Accordion>
  );
};

export default NavAccordionItem;
